// eslint-disable-next-line import/prefer-default-export
import { actions, Api, Queue } from 'ion-lib';

const holeVorbelegungenHausrat = (cbSuccess = () => {
  // This is intentional
}) => (dispatch, getState) => {
  const searchParams = new URLSearchParams(window.location.search);
  const auswahl = searchParams.get('auswahl');
  Queue.enqueue(() => {
    const options = {
      method: 'GET',
      timeout: 0,
    };
    const { appDaten } = getState();
    const payload = {
      vtnr: appDaten.vtnr,
      vkanal: appDaten.backendVkanal || appDaten.vkanal,
      mandant: appDaten.mandant,
      bausteinauswahl: auswahl || '0',
    };

    return Api.send(
      'holeVorbelegungen',
      payload,
      (response) => {
        dispatch(actions.updateByName('appDaten.message', response.nachrichten));
        cbSuccess(response);
      },
      (response) => {
        dispatch(actions.updateByName('appDaten.errorBoundary', response));
      },
      options,
      dispatch,
      getState,
    );
  });
};

export default holeVorbelegungenHausrat;
